export default __webpack_public_path__ + "static/media/viber_image_2022-06-06_11-14-56-074.734ac013.jpg";